import Types from '../../action/types';

const defaultState = {
    userRole:{},
    // userInfo:{},
};

export default function onAction(state = defaultState, action) {
    switch (action.type) {
        case Types.GENERAL_LOGIN:
            return {
                ...state,
                userRole: action.userRole,
                // userInfo:action.userInfo
                // tableLoading:true
            }
        
        default:
            return state;
    }
}